import { SEOHead } from "@/components/SEOHead";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useEffect } from "react";

import { useLanguage } from "@/contexts/LanguageContext";

const FreeConsultation = () => {
  const { t, language } = useLanguage();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://app-cdn.clickup.com/assets/js/forms-embed/v1.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [language]);

  // ClickUp script is now loaded globally in index.html
  return (
    <div className="min-h-screen bg-background font-sans">
      <SEOHead 
        title={t('freeConsultation.title')}
        description={t('freeConsultation.subtitle')}
        canonical="/free-consultation"
      />
      <Navbar />
      
      <main className="pt-28 pb-16 md:pt-36 md:pb-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <div className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary font-bold text-xs mb-6 tracking-widest uppercase">
              {t('freeConsultation.badge')}
            </div>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-navy-950 mb-6 tracking-tight">
              {t('freeConsultation.title')}
            </h1>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              {t('freeConsultation.subtitle')}
            </p>
          </div>

          <div className="max-w-7xl mx-auto bg-white rounded-[2rem] shadow-2xl border border-slate-100 overflow-hidden w-full">
            <iframe 
              className="clickup-embed clickup-dynamic-height" 
              src={language === 'ru' 
                ? "https://forms.clickup.com/9017049670/f/8cqagj6-54417/7YOMGM7RWLV8P6HFL3" 
                : "https://forms.clickup.com/9017049670/f/8cqagj6-26157/KXPMILGPSCE46SJD7M"} 
              onWheel={() => {}} 
              width="100%" 
              height="100%" 
              style={{ background: 'transparent', border: 'none', width: '100%', minWidth: '100%' }}
            />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default FreeConsultation;
